
import { SelectOption } from '../model/select.option';

export enum SubmissionStatus {
  ACTIVE = 'ACTIVE',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  PENDING = 'PENDING',
  WITHDRAWN = 'WITHDRAWN',
  DELETED = 'DELETED'
  // MAJOR_REVISION = 'MAJOR_REVISION',
  // MINOR_REVISION = 'MINOR_REVISION'
}

// Colors are resolved via CSS variables defined in _colors.scss :root
export const SubmissionStatusStyles = Object.freeze({
  'ACCEPTED': Object.freeze({
    'fontSet': 'material-symbols-outlined',
    'fontIcon': 'thumb_up',
    'color': '#99FF99'
  }),
  'ACTIVE': Object.freeze({
    'fontSet': 'material-symbols-outlined',
    'fontIcon': 'check',
    'color': '#FFFF55'
  }),
  'PENDING': Object.freeze({
    'fontSet': 'material-symbols-outlined',
    'fontIcon': 'priority_high',
    'color': '#FAB65C'
  }),
  'REJECTED': Object.freeze({
    'fontSet': 'material-symbols-outlined',
    'fontIcon': 'thumb_down',
    'color': '#FFBDBD'
  }),
 'WITHDRAWN': Object.freeze({
    // Material Symbol "inventory_2" via codepoint PUA (U+E1A1). Usamos o
    // caractere direto porque a ligadura de 11 glyphs (`inventory_2`)
    // não é aplicada pelo shaper — o `inventory` (ligadura mais curta)
    // ganha primeiro e o "_2" sai como texto literal. O codepoint dribla
    // o problema (cmap → glyph direto, sem GSUB).
    'fontSet': 'material-symbols-outlined',
    'fontIcon': '\uE1A1',
    'color': '#DDDDDD'
  }),
  'DELETED': Object.freeze({
    'fontSet': 'material-symbols-outlined',
    'fontIcon': 'delete',
    'color': '#DDDDDD'
  })
});

export namespace SubmissionStatus {
  export function toIterable(): Array<string> {
    return Object.keys(SubmissionStatus).filter(key => typeof SubmissionStatus[key] !== 'function' && key !== SubmissionStatus.DELETED);
  }

  export function toString(status: SubmissionStatus): string {
    return `status.${status}`;
  }

  export function toClass(status: SubmissionStatus) {
    return status.toLowerCase();
  }

  export function toSelectable(): Array<SelectOption> {
    return SubmissionStatus.toIterable().map(value => ({
      id: value,
      value: SubmissionStatus[value]
    }));
  }

  export function icon(status: SubmissionStatus): { fontSet: string, fontIcon: string }  {
    switch (status) {
      case SubmissionStatus.PENDING:
        return {
          'fontSet': 'material-symbols-outlined',
          'fontIcon': 'priority_high'
        };
      case SubmissionStatus.ACTIVE:
        return {
          'fontSet': 'material-symbols-outlined',
          'fontIcon': 'check'
        };
      case SubmissionStatus.ACCEPTED:
        return {
          'fontSet': 'material-symbols-outlined',
          'fontIcon': 'thumb_up'
        };
      case SubmissionStatus.REJECTED:
        return {
          'fontSet': 'material-symbols-outlined',
          'fontIcon': 'thumb_down'
        };
      case SubmissionStatus.WITHDRAWN:
        return {
          // "inventory_2" via codepoint PUA (vide WITHDRAWN no map acima).
          'fontSet': 'material-symbols-outlined',
          'fontIcon': '\uE1A1'
        };
      case SubmissionStatus.DELETED:
        return {
          'fontSet': 'material-symbols-outlined',
          'fontIcon': 'delete'
        };
      default:
        return {
          'fontSet': 'material-symbols-outlined',
          'fontIcon': 'more_horiz'
        };
    }
  }
}
